import React from "react";

function WarningIcon() {
  return (
    <svg
      width="105"
      height="105"
      viewBox="0 0 105 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="52.5" cy="52.5" r="52.5" fill="#FFEBEE" />
      <circle cx="52.5" cy="52.5" r="37.5" fill="#FFDEDE" />
      <path
        d="M52.9997 31.3334C64.9662 31.3334 74.6663 41.0357 74.6663 53C74.6663 64.9644 64.9662 74.6667 52.9997 74.6667C41.0332 74.6667 31.333 64.9644 31.333 53C31.333 41.0357 41.0332 31.3334 52.9997 31.3334ZM52.9997 34.9452C43.0438 34.9452 34.9448 43.0442 34.9448 53C34.9448 62.9559 43.0438 71.0549 52.9997 71.0549C62.9555 71.0549 71.0545 62.9559 71.0545 53C71.0545 43.0442 62.9555 34.9452 52.9997 34.9452ZM52.9975 58.421C53.5716 58.421 54.1221 58.6491 54.528 59.055C54.934 59.4609 55.162 60.0115 55.162 60.5855C55.162 61.1596 54.934 61.7101 54.528 62.1161C54.1221 62.522 53.5716 62.75 52.9975 62.75C52.4234 62.75 51.8729 62.522 51.467 62.1161C51.0611 61.7101 50.833 61.1596 50.833 60.5855C50.833 60.0115 51.0611 59.4609 51.467 59.055C51.8729 58.6491 52.4234 58.421 52.9975 58.421ZM52.9867 42.1667C53.3797 42.1662 53.7596 42.3082 54.056 42.5663C54.3524 42.8245 54.5452 43.1813 54.5987 43.5707L54.6138 43.7895L54.6225 53.5439C54.6229 53.9558 54.4669 54.3525 54.186 54.6537C53.9051 54.955 53.5203 55.1383 53.1093 55.1667C52.6984 55.195 52.2921 55.0663 51.9724 54.8064C51.6528 54.5466 51.4438 54.1751 51.3877 53.767L51.3725 53.546L51.3638 43.7939C51.3636 43.5803 51.4054 43.3688 51.4869 43.1713C51.5684 42.9739 51.6881 42.7945 51.839 42.6434C51.9899 42.4923 52.1692 42.3724 52.3665 42.2906C52.5638 42.2088 52.7731 42.1667 52.9867 42.1667Z"
        fill="#F44336"
      />
    </svg>
  );
}

export default WarningIcon;
